import { faAngleUp } from "@fortawesome/free-solid-svg-icons/faAngleUp";
import { Popover } from "../../utils/local-antd";
import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";
import styled, { createGlobalStyle } from "styled-components";

import i18n from "../../i18n";
import { PageMeta } from "../../model/meta/PageMeta";
import { TaskFilterReminder } from "../../model/task/types/TaskFilterReminder.enum";
import { useAppDispatch, useAppSelector } from "../../redux/store";
import { taskActions } from "../../redux/task/task.slice";
import { userSliceSelectors } from "../../redux/user/user.selector";
import { Spacing } from "../../theme/Spacing";
import { Button } from "../Button";
import { FloatingTodayTasksContent } from "./FloatingTodayTasksContent";
import { appSliceSelectors } from "../../redux/app/app.selector";
import { appActions } from "../../redux/app/app.slice";

const StyledButton = styled(Button)<{ menuOpen: boolean }>`
  margin: 0;
  flex-shrink: 0;
  width: fit-content;
  padding: calc(${Spacing.s} / 2) ${Spacing.m};
  font-weight: bold;
  border-inline-start: ${({ theme }) => `2px solid ${theme.sub}`};
  border-radius: 0;
  background-color: ${({ theme }) => theme.darkMain};
  margin-block: -2px;

  &:hover {
    filter: brightness(1.3);
    -webkit-filter: brightness(1.3);
  }

  svg {
    transition: all 0.3s ease-in-out;
    transform-origin: center;
  }

  ${({ menuOpen }) =>
    menuOpen
      ? `
        svg {
          transform: rotate(180deg);
        }
  `
      : ""}
`;

const ThemedPopover = createGlobalStyle`
  .today-tasks-popover {
    inset-inline-end: ${Spacing.m} !important;

    .ant-popover-inner {
      border-radius: 1rem;
    }

    .ant-popover-inner-content {
      padding: 0;
    }
  }
`;

export const FloatingTodayTasks: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const userId = useAppSelector(userSliceSelectors.selectLoggedInUserId)!;
  const open =
    useAppSelector(appSliceSelectors.floatingTodayTasksVisible) === true;

  const setOpen = (visible: boolean) => {
    dispatch(appActions.setFloatingTodayTasksVisible(visible));
  };

  const onChangeVisibility = (visible: boolean) => {
    if (visible) {
      dispatch(
        taskActions.getTodayTasks({
          userId,
          meta: PageMeta.create({ page: 0, count: 25 }),
          reminder: TaskFilterReminder.TODAY,
        }),
      );
    }
  };

  return (
    <Fragment>
      <Popover
        content={<FloatingTodayTasksContent />}
        trigger={"click"}
        placement={i18n.language === "ar" ? "topRight" : "topLeft"}
        open={open}
        onOpenChange={setOpen}
        overlayClassName="today-tasks-popover"
        forceRender
        afterOpenChange={onChangeVisibility}
      >
        <StyledButton
          icon={faAngleUp}
          menuOpen={open}
          onClick={() => setOpen(!open)}
        >
          {t("floatingTasksMenu.title")}
        </StyledButton>
      </Popover>

      <ThemedPopover />
    </Fragment>
  );
};
